import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx="6.942" cy="7.353" r="6.942" fill="#161C21" opacity=".3" /><path d="M4.083 7.25l1.975 2.144L9.8 5.311" stroke="#fff" strokeWidth="1.16" strokeLinecap="round" strokeLinejoin="round" /></svg>);